import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    detailsWrapper: {
        flex: 1,
        display: 'flex'
    },
    input: {
        marginBottom: 16
    },
    picker: {
        marginTop: 15,
        marginBottom: 15
    },
    detailsRow: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center'
    },
    detailsNameColumn: {
        flex: 1,
        color: theme.quaternary,
        fontWeight: 'bold'
    },
    detailsValueColumn: {
        flex: 1,
        display: 'flex',
        alignItems: 'center'
    },
    detailsValueColumnReportDescr: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    detailsInfoWrapper: {
        paddingRight: 20,
        flex: 2
    },
    detailsInfoWrapperRight: {
        flex: 1
    },
    arrowBackIcon: {
        color: theme.primary
    },
    reportsTable: {
        maxHeight: 'calc(100% - 70px)'
    },
    modalButtons: {
        marginTop: 20,
        display: 'flex',
        gap: 15,
        justifyContent: 'flex-end'
    },
    select: {
        marginBottom: 16
    },
    link: {
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.primary,
        fontWeight: 'bold'
    },
    section: {
        marginTop: 16
    },
    reportTypeWithIcon: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: 10,
        gap: 5
    },
    tomPicture: {
        width: '100%',
        height: 'auto',
        cursor: 'pointer'
    },
    headerButtonsWrapper: {
        width: '40%',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '2%'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textareaSection: {
        display: 'flex',
        backgroundColor: 'white',
        marginTop: '2%'
    },
    commentInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        flex: 1,
        marginBottom: '10px',
        marginTop: '9px'
    },
    commentTextSection: {
        flex: 1,
        color: theme.quaternary,
        fontWeight: 'bold',
        marginTop: '25px',
        marginBottom: '-30px'
    },
    addCommentButton: {
        marginBottom: 20,
        cursor: 'pointer',
        color: theme.primary,
        fontWeight: 'bold',
        fontSize: '15',
        marginTop: '-8px'
    },
    iconUnderlay: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        width: 20,
        height: 20,
        marginRight: 8
    },
    detailsSharingHistoryBox: {
        width: '400px',
        marginBottom: '10px'
    },
    detailsSharingHistoryItem: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        paddingBottom: 4,
        paddingTop: 4,
        '&:not(:last-child)': {
            borderBottom: `1px solid ${theme.palette.divider}`
        }
    },
    leftColumn: {
        flex: 0.7
    },
    rightColumn: {
        flex: 1,
        overflow: 'hidden'
    },
    rightColumnHover: {
        overflow: 'auto',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
            width: '8px',
            '&:hover': {
                background: '#555'
            }
        }
    },
    inlineDiv: {
        display: 'inline',
        whiteSpace: 'nowrap'
    },
    clickableText: {
        cursor: 'pointer',
        textDecoration: 'underline'
    }
}))
